import { WSAlert } from "@wingspanhq/fe-component-library";
import { RequirementExpirationStatus } from "@wingspanhq/payments/dist/interfaces";
import { useQueryPayeeRowsSummary } from "../../../../query/search/payee/queries/useQueryPayeeRowsSummary";
import { useGoToBulkReviewRequirements } from "../../../BulkReview/paths";
import { PayeeFilterRequirementStatus } from "./filters/types";

type Props = {};

export const AlertExpiringRequirements: React.FC<Props> = props => {
  const goToBulkReviewRequirements = useGoToBulkReviewRequirements();

  const querySummary = useQueryPayeeRowsSummary({
    filter: {
      "requirements.expirationStatus": RequirementExpirationStatus.Expiring
    }
  });

  if (!querySummary.data?.listSize || querySummary.data.listSize < 2) {
    return null;
  }

  return (
    <WSAlert
      theme="info"
      my="L"
      title="Multiple requirements expiring soon"
      icon="collection"
      action={{
        text: "View requirements",
        onClick: () => {
          goToBulkReviewRequirements({
            filter: {
              status: PayeeFilterRequirementStatus.Expiring
            }
          });
        }
      }}
    >
      Multiple requirements are expiring soon. Contractors have been reminded to
      renew their documents and the requirements are now awaiting contractor
      renewals.
    </WSAlert>
  );
};
